import { useState, useEffect } from 'react';
import axios from 'axios';
import automobyApi from '../Api';

export const useSalesAmount = (carId) => {
   const api = "" 
   //useEffect(() => {
   // fetchAmounts(carId, typeId);
   //}, []);

   const fetchAmounts = () => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        car_id: carId,
      };
  
      automobyApi
        .post("/salesAmount/list", requestData)
        .then(response => {
          resolve(response.data.amounts);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

 
  
  const addAmountSale = (newAmount) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/salesAmount/sale/add", newAmount)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const removeAmount = (amountId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        amount_id: amountId
      };
  
      automobyApi
        .post("/salesAmount/remove", requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const fetchBySaleId = (saleId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        sale_id: saleId,
      };
  
      automobyApi
        .post("/salesAmount/sale/list", requestData)
        .then(response => {
          resolve(response.data.amounts);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

   
  const saleAmountService = {
    fetchAmounts: fetchAmounts,
    addAmountSale: addAmountSale,

    removeAmount: removeAmount, 
    fetchBySaleId: fetchBySaleId
   };

  return { saleAmountService };
 
}